import Vue from "vue";
import Top from "./Top.vue";
import "@babel/polyfill";
import vueSmoothScroll from "vue-smooth-scroll";

Vue.config.productionTip = false;

Vue.use(vueSmoothScroll, {
  updateHistory: false
});

require('@/assets/scss/main.scss');

new Vue({
  render: h => h(Top)
}).$mount("#app");